const NigerSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112026)">
      <path
        d="M1.98453 11.3046C0.713125 13.9339 0 16.8837 0 20.0002C0 23.1167 0.713125 26.0664 1.98453 28.6958L20 30.435L38.0155 28.6958C39.2869 26.0664 40 23.1167 40 20.0002C40 16.8837 39.2869 13.9339 38.0155 11.3046L20 9.56543L1.98453 11.3046Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.98486 28.6953C5.21971 35.3852 12.0704 39.9997 19.9996 39.9997C27.9288 39.9997 34.7795 35.3852 38.0144 28.6953H1.98486Z"
        fill="#6DA544"
      />
      <path
        d="M1.98486 11.3044H38.0144C34.7795 4.61445 27.9288 0 19.9996 0C12.0705 0 5.21971 4.61445 1.98486 11.3044Z"
        fill="#FF9811"
      />
      <path
        d="M19.9999 26.9559C23.8419 26.9559 26.9564 23.8414 26.9564 19.9995C26.9564 16.1575 23.8419 13.043 19.9999 13.043C16.158 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.158 26.9559 19.9999 26.9559Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112026">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NigerSvg;
